import { createLogic, Logic } from 'redux-logic';
import { actionTypes } from 'reducer/adas';
import { getIncidentsTypes } from 'api/adas';
import { adasActions } from 'reducer/adas';
import { IModalItem } from 'views/pages/Adas/IncidentsDynamic/IncidentsDynamic.types';

const getTypes = createLogic({
  type: actionTypes.GET_INCIDENTS_TYPES,
  latest: true,
  warnTimeout: 0,

  async process(_, dispatch) {
    const incidentsTypes = await getIncidentsTypes();
    dispatch(adasActions.setIncidentsTypes(incidentsTypes));
  }
});

const updateTypes = createLogic({
  type: actionTypes.UPDATE_INCIDENTS_TYPES,
  latest: true,
  warnTimeout: 0,

  async process({action}: {action: {payload: IModalItem[]}}, dispatch) {
    const list = action.payload;

    const incidentsTypes = list.reduce((acc:any, current: IModalItem) => {
        const {key, primaryField, ...rest} = current;
      acc[`${current.incidentType}`] = rest;
      return acc;
    }, {});

    dispatch(adasActions.setIncidentsTypes(incidentsTypes));
  }
});

export default [
  getTypes,
  updateTypes
] as Logic[];